var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClauseCheckUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 10.05V14.2675V14.25V21.25V10.05ZM10.4 22.65C10.015 22.65 9.68542 22.5129 9.41125 22.2387C9.13708 21.9646 9 21.635 9 21.25V10.05C9 9.66499 9.13708 9.33541 9.41125 9.06124C9.68542 8.78708 10.015 8.64999 10.4 8.64999H16L20.2 12.85V14.6C19.9783 14.5067 19.7508 14.4337 19.5175 14.3812C19.2842 14.3287 19.045 14.2908 18.8 14.2675V13.55H15.3V10.05H10.4V21.25H14.6175C14.8042 21.53 15.0142 21.7896 15.2475 22.0287C15.4808 22.2679 15.7375 22.475 16.0175 22.65H10.4ZM18.45 20.55C18.94 20.55 19.3542 20.3808 19.6925 20.0425C20.0308 19.7042 20.2 19.29 20.2 18.8C20.2 18.31 20.0308 17.8958 19.6925 17.5575C19.3542 17.2192 18.94 17.05 18.45 17.05C17.96 17.05 17.5458 17.2192 17.2075 17.5575C16.8692 17.8958 16.7 18.31 16.7 18.8C16.7 19.29 16.8692 19.7042 17.2075 20.0425C17.5458 20.3808 17.96 20.55 18.45 20.55ZM22.02 23.35L20.13 21.46C19.885 21.6233 19.6196 21.7458 19.3337 21.8275C19.0479 21.9092 18.7533 21.95 18.45 21.95C17.575 21.95 16.8312 21.6437 16.2188 21.0312C15.6062 20.4187 15.3 19.675 15.3 18.8C15.3 17.925 15.6062 17.1812 16.2188 16.5687C16.8312 15.9562 17.575 15.65 18.45 15.65C19.325 15.65 20.0687 15.9562 20.6812 16.5687C21.2937 17.1812 21.6 17.925 21.6 18.8C21.6 19.1033 21.5592 19.3979 21.4775 19.6837C21.3958 19.9696 21.2733 20.235 21.11 20.48L23 22.37L22.02 23.35Z",
    fill: "#6A6A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClauseCheckUnselected);
export default __webpack_public_path__ + "static/media/clause_check_unselected.892f30b6237f30a7c824ec5fdc407235.svg";
export { ForwardRef as ReactComponent };